import hUpload from './src/h-upload'

hUpload.install = function (Vue) {
  Vue.component(hUpload.name, hUpload);
};

export default hUpload;